import toNumber from 'lodash/toNumber';
import * as React from 'react';

type PropsT = {
  fromNumberCountryCode: number | null;
  value: string;
  isValidNumber: boolean;

  onChangeInput: (string) => void;
};

export default class SearchInputField extends React.Component<PropsT> {
  input: React.RefObject<any>;

  constructor(props: PropsT) {
    super(props);

    this.input = React.createRef();
  }

  componentDidMount() {
    if (this.input.current) {
      this.input.current.focus();
    }
  }

  render() {
    const { fromNumberCountryCode, value, isValidNumber, onChangeInput } =
      this.props;

    let prefix: JSX.Element | null = null;

    if (
      value.indexOf('+') === -1 &&
      isNaN(toNumber(value)) === false &&
      fromNumberCountryCode !== null &&
      isValidNumber === false
    ) {
      prefix = (
        <span className="input-group-addon">+{fromNumberCountryCode}</span>
      );
    }

    return (
      <div className="search-users-to-transfer">
        <div className={'form-group'}>
          <div className="input-group">
            {prefix}
            <input
              type="search"
              ref={this.input}
              id="search-users"
              className="form-control search-users-input"
              placeholder="Search contacts..."
              value={value}
              onChange={onChangeInput}
            />
          </div>
        </div>
      </div>
    );
  }
}
